/* eslint-disable no-unused-vars */

import React, { useEffect } from 'react'


const ChangeLevelDetails = () => {
  
  
  return (
    <div>
        <h1>Change Level Details Page</h1>
    </div>
  )
}

export default ChangeLevelDetails